<template>
  <div id="red_order" :class="isFull === 1 ? 'red_log0 top_information_fixed1' : 'red_log1'">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      :title="$t('column.claim_record')"
      left-arrow
      fixed
      placeholder
      @click-left="goBack"
      class="custom-nav-bar"
    />

    <!-- 红包信息头部 -->
    <div class="red-packet-header">
      <div class="header-top">
        <div class="header-left">
          <span class="time">{{ packetInfo.create_time }}</span>
        </div>
        <div class="header-right">
          <span class="condition">{{ packetInfo.content }}</span>
        </div>
      </div>
      
      <div class="packet-main">
        <div class="packet-left">
          <div class="packet-icon">
            <img :src="packetInfo.avatar" v-if="packetInfo.avatar"/>
          </div>
          <div class="packet-info">
            <div class="packet-name">{{ packetInfo.user_nickname }}</div>
             <div class="packet-uid">ID:{{ packetInfo.user_id }}</div>
            <div class="packet-tags">
              <span class="tag tag-gift">
               <span class="tag-coin"><van-icon name="manager" size="12px" /></span>
                <span class="tag-num">{{ packetInfo.people_quantity }}</span>
              </span>
              <span class="tag tag-coin">
               <span class="tag-coin"><img src="../assets/img/coin7.png" alt=""></span>
                <span class="tag-num">{{ packetInfo.diamonds_quantity }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="packet-right">
          <div class="receive-count">{{ $t('column.people_claimed_rewards', { number: packetInfo.receive_quantity }) }}</div>
          <div class="refund-info" v-if="packetInfo.return_coin">
            {{ $t('column.return_coin') }}:  <img src="../assets/img/coin7.png" alt=""> </img>{{ packetInfo.return_coin || 0 }}
          </div>
           <div class="refund-info" v-else>
            {{ $t('column.In_progress') }}
          </div>
        </div>
      </div>
    </div>

    <!-- 领取列表 -->
    <div class="receive-list-wrapper">
      <div class="receive-list" v-if="receiveList.length > 0">
        <div 
          class="receive-item" 
          v-for="(item, index) in receiveList" 
          :key="index"
        >
          <div class="item-left">
            <img 
              :src="item.avatar" 
              alt="avatar" 
              class="avatar"
            />
            <div class="user-info">
              <div class="user-name">
                {{ item.user_nickname }}
                <span v-if="item.country_flag" class="flag">{{ item.country_flag }}</span>
              </div>
              <div class="user-id">ID:{{ item.user_id }}</div>
            </div>
          </div>
          <div class="item-right">
            <span class="coin-amount">
              <img src="../assets/img/coin7.png" alt="">
              {{ item.diamonds_quantity }}
            </span>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div class="empty-wrapper" v-else>
        <div class="empty-icon"></div>
        <div class="empty-text">{{ $t('column.no_data') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import '../assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"

export default {
  name: 'RedOrder',
  data() {
    return {
      packetInfo: {},
      receiveList: [],
      loading: false,
      finished: false,
      isFull: 0
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0
    this.getList()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getList() {
        const token = this.$route.query.token
        const red_packet_id = this.$route.query.red_packet_id
        this.loading = true
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_h5&act=red_packet_detail", {
        params: {
          token: token,
          id: red_packet_id
        }
      }).then(res => {
         this.loading = false
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        } else {
            this.packetInfo = res.data.data.info
            this.receiveList = res.data.data.list
        }
      }).catch(err => {
        console.error('获取红包信息失败:', err)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/red_order.vue